// src/utils/styleBuilders.js
const clamp01 = (n) => Math.min(1, Math.max(0, Number(n)));
const hexToRgb = (hex) => {
  const m = String(hex).trim().match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
  return m ? { r: parseInt(m[1],16), g: parseInt(m[2],16), b: parseInt(m[3],16) } : null;
};
export const toRgba = (hex, opacity=1) => {
  if (/^rgba?\(/i.test(hex) || /^[a-z]+$/i.test(hex)) return hex;
  const rgb = hexToRgb(hex); if (!rgb) return hex;
  const a = clamp01(opacity);
  return a >= 1 ? `#${String(hex).replace('#','')}` : `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${a})`;
};
export const mapAngle = (a) => {
  const x = String(a || '').trim().toLowerCase();
  if (['to bottom','to top','to right','to left','45deg','135deg','0deg','90deg','180deg','270deg'].includes(x)) return x;
  if (x==='bottom') return 'to bottom';
  if (x==='top') return 'to top';
  if (x==='left') return 'to right';
  if (x==='right') return 'to left';
  return 'to bottom';
};
// --- background container
export function buildCompositeBackground(appearance) {
  const imgUrl = appearance?.background?.image?.imageUrl?.trim();
  const colorCfg = appearance?.background?.color || {};
  const type = String(colorCfg?.type || 'NONE').toUpperCase();

  // 1) overlay → como linear-gradient (mesma sintaxe serve para SOLID também)
  let overlay = null;
  if (type === 'SOLID') {
    const { solidColor='#000000', opacity=0.0 } = colorCfg.solid || {};
    const c = toRgba(solidColor, opacity);
    overlay = `linear-gradient(${c}, ${c})`;
  } else if (type === 'GRADIENT') {
    const { start='#000000', end='#000000', opacity=0.0, angle='to bottom' } = colorCfg.gradient || {};
    const a  = mapAngle(angle);
    const c1 = toRgba(start, opacity);
    const c2 = toRgba(end || start, opacity);
    overlay = `linear-gradient(${a}, ${c1}, ${c2})`;
  }

  // 2) monta as camadas na ordem correta (overlay primeiro)
  const layers = [];
  if (overlay) layers.push(overlay);
  if (imgUrl)  layers.push(`url("${imgUrl}")`);

  // 3) se nada definido, retorna vazio
  if (!layers.length) return {};

  return {
    backgroundImage: layers.join(', '),
    // aplica sizing/pos/repeat para ambas as camadas (2 valores quando há 2 camadas)
    backgroundSize:   layers.length === 2 ? 'auto, cover' : (imgUrl ? 'cover' : 'auto'),
    backgroundPosition: layers.length === 2 ? 'center, center' : 'center',
    backgroundRepeat: layers.length === 2 ? 'no-repeat, no-repeat' : 'no-repeat',
    minHeight: '100vh',
  };
}

// --- card body (ignora head)
export const buildCardBodyCss = (appearance) => {
  const color = appearance?.card?.body?.color || {};
  const t = String(color.type || 'NONE').toUpperCase();
  if (t === 'SOLID') {
    const { solidColor='#0a0a0a', opacity=1 } = color.solid || {};
    return { background: toRgba(solidColor, opacity) };
  }
  if (t === 'GRADIENT') {
    const { start='#fff', end='#000', opacity=1, angle='to bottom' } = color.gradient || {};
    const a = mapAngle(angle);
    const c1 = toRgba(start, opacity), c2 = toRgba(end||start, opacity);
    return { background: `linear-gradient(${a}, ${c1}, ${c2})` };
  }
  return {};
};
// --- botões
export const buildButtonStripCss = (linksAppearance) => {
  const cfg = linksAppearance?.color || {};
  const t = String(cfg.type || 'SOLID').toUpperCase();
  if (t === 'GRADIENT') {
    const g = cfg.gradient || {};
    const a = mapAngle(g.angle || 'to right');
    const start = g.start || '#000', end = g.end || start;
    return { background: `linear-gradient(${a}, ${start}, ${end}, ${start}, ${end})`, };
  }
  const hex = cfg?.solid?.solidColor || '#000';
  return { background: toRgba(hex, 1) };
};
export const buttonRadius = (linksAppearance) => Number(linksAppearance?.borderRadius ?? 10);
export const buttonFontColor = (linksAppearance) => (linksAppearance?.font?.color || '#fff');
